import { render, staticRenderFns } from "./IconError.vue?vue&type=template&id=c766c0bc&scoped=true&"
import script from "./IconError.vue?vue&type=script&lang=ts&"
export * from "./IconError.vue?vue&type=script&lang=ts&"
import style0 from "./IconError.vue?vue&type=style&index=0&id=c766c0bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c766c0bc",
  null
  
)

export default component.exports